import getColour from '@lendi-ui/commons/colours';
import Call from '@lendi-ui/icon/Call';

import { formatPhoneNumber, parsePhoneNumber } from '@funnels/utils';

import { Prefix } from '../_common/style';
import TextInputField, { TextInputFieldProps } from '.';

export const MobileInputFieldLabel = 'Mobile';
export const MobileInputFieldValidationFailMessage = 'Please enter a valid mobile number.';

const MobileInputField = (props: TextInputFieldProps) => (
  <TextInputField
    {...props}
    before={
      <Prefix>
        <Call color={getColour('fill', 'accent')} width="24px" height="24px" />
      </Prefix>
    }
    fixedLength={12}
    format={formatPhoneNumber}
    label={props.label || MobileInputFieldLabel}
    parse={parsePhoneNumber}
    validationFailMessage={MobileInputFieldValidationFailMessage}
  />
);

export default MobileInputField;
